<template>
  <div class="business-blog-learning-habits-page">
    <section class="container section business-blog-learning-habits-page__post-content" v-html="post" />

    <get-started i18n-key="business" />
  </div>
</template>

<script>
import businessApi from "@/api/business"
import GetStarted from "@/pages/business/components/get-started"

export default {
  name: "BusinessBlogLearningHabits",
  components: {
    GetStarted
  },
  data: () => ({
    post: ""
  }),
  mounted() {
    return businessApi.learningHabitsPost().then((response) => {
      this.post = response
    })
  }
}
</script>

<style lang="scss">
.business-blog-learning-habits-page {
  $root: &;

  &__post-content > * {
    @include media(min-width, m) {
      padding-right: $spacing-64;
      padding-left: $spacing-64;
    }
  }

  blockquote {
    margin-right: 0;
    margin-bottom: $spacing-64;
    margin-left: 0;
    padding: $spacing-64;

    background-color: $pale-mint-grey;

    p {
      @include font-style(r1);
    }

    p:last-of-type {
      margin-bottom: 0;
    }
  }

  ul {
    margin-left: $spacing-16;

    list-style-position: outside;
    list-style-type: disc;
  }

  li {
    margin-bottom: $spacing-16;
  }

  &__figure {
    display: flex;

    flex-direction: column;
    justify-content: center;

    text-align: center;

    @include media(min-width, m) {
      padding: $spacing-48;
    }
  }

  &__image {
    width: 100%;
    height: auto;
  }

  &__figcaption {
    margin-bottom: $spacing-8;
  }
}
</style>
